<template>
  <div class="blessing-mgn-page">
    <!-- 筛选区 -->
    <div class="filter-bar">
      <el-form :inline="true" :model="filter" size="medium" label-width="auto">
        <el-form-item label="祝福类型">
          <el-select
            v-model="filter.blessingType"
            placeholder="请选择祝福类型"
            clearable
          >
            <el-option label="生日祝福" value="BIRTHDAY" />
            <el-option label="入职祝福" value="WORKAHOLICS" />
            <el-option label="周年祝福" value="ANNIVERSARY" />
          </el-select>
        </el-form-item>

        <el-form-item label="祝福年份">
          <el-input
            v-model.number="filter.blessingYear"
            type="number"
            placeholder="请输入年份"
            clearable
          />
        </el-form-item>

        <el-form-item label="收祝福人工号">
          <el-input
            v-model="filter.receiverNo"
            placeholder="请输入收祝福人工号"
            clearable
          />
        </el-form-item>

        <el-form-item label="送祝福人工号">
          <el-input
            v-model="filter.senderNo"
            placeholder="请输入送祝福人工号"
            clearable
          />
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="filter.status" placeholder="请选择状态" clearable>
            <el-option label="正常" value="1" />
            <el-option label="已禁用" value="0" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 工具栏 -->
    <!-- <div class="table-toolbar">
      <el-button
        type="danger"
        size="small"
        @click="batchDelete"
        :disabled="selectedRows.length == 0"
        >批量禁用</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="batchRestore"
        :disabled="selectedRows.length == 0"
        >批量恢复</el-button
      >
    </div> -->

    <!-- 主表格 -->
    <el-table
      ref="table"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column prop="id" label="ID" align="center" width="80" />
      <el-table-column
        prop="blessingType"
        label="祝福类型"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.blessingType == 'BIRTHDAY'">生日祝福</span>
          <span v-else-if="scope.row.blessingType == 'WORKAHOLICS'">入职祝福</span>
          <span v-else-if="scope.row.blessingType == 'ANNIVERSARY'">周年祝福</span>
          <span v-else>{{ scope.row.blessingType }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="blessingYear"
        label="祝福年份"
        align="center"
        width="100"
      />
      <el-table-column prop="receiverNo" label="收祝福人工号" align="center" />
      <el-table-column
        prop="receiverName"
        label="收祝福人姓名"
        align="center"
      />
      <el-table-column prop="senderNo" label="送祝福人工号" align="center" />
      <el-table-column prop="senderName" label="送祝福人姓名" align="center" />
      <el-table-column
        prop="content"
        label="祝福内容"
        align="center"
        min-width="200"
        show-overflow-tooltip
      />
      <el-table-column
        prop="createdAt"
        label="祝福时间"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.createdAt
              ? moment(scope.row.createdAt).format("YYYY-MM-DD HH:mm:ss")
              : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == 1 ? 'success' : 'danger'"
            size="small"
          >
            {{ scope.row.status == 1 ? "正常" : "禁用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 1"
            type="danger"
            size="small"
            @click="handleDelete(scope.row)"
          >
            禁用
          </el-button>
          <el-button
            v-else
            type="success"
            size="small"
            @click="handleRestore(scope.row)"
          >
            启用
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      class="pagination"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="pageData.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageData.pageSize"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
    />
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/medal";

export default {
  name: "BlessingSet",
  data() {
    return {
      moment,
      filter: {
        blessingType: "",
        blessingYear: null,
        receiverNo: "",
        senderNo: "",
        status: null,
      },
      pageData: { page: 1, pageSize: 20 },
      total: 0,
      tableData: [],
      tableLoading: false,
      selectedRows: [],
    };
  },
  mounted() {
    this.queryData();
    // 默认设置当前年份
    this.filter.blessingYear = new Date().getFullYear();
  },
  methods: {
    handleSearch() {
      this.pageData.page = 1;
      this.queryData();
    },
    resetQuery() {
      this.pageData.page = 1;
      this.pageData.pageSize = 20;
      this.filter = {
        blessingType: "",
        blessingYear: new Date().getFullYear(),
        receiverNo: "",
        senderNo: "",
        status: null,
      };
      this.queryData();
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.pageData.page = 1;
      this.queryData();
    },
    handlePageChange(page) {
      this.pageData.page = page;
      this.queryData();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    async queryData() {
      try {
        this.tableLoading = true;
        const params = {
          page: this.pageData.page,
          pageSize: this.pageData.pageSize,
          ...this.filter,
        };

        // 移除空值参数
        Object.keys(params).forEach((key) => {
          if (
            params[key] === "" ||
            params[key] === null ||
            params[key] === undefined
          ) {
            delete params[key];
          }
        });

        const res = await api.queryBlessingCommentByPage(params);
        this.tableData = res.data?.list || [];
        this.total = res.data?.total || 0;
      } catch (error) {
        console.error("查询祝福记录失败:", error);
        this.$message.error("查询失败");
      } finally {
        this.tableLoading = false;
      }
    },

    async handleDelete(row) {
      this.$confirm(
        "确定要禁用这条祝福记录吗？",
        "操作确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            await api.editBlessingComment({
              id: row.id,
              status: 0,
            });
            this.$message.success("禁用成功");
            this.queryData();
          } catch (error) {
            this.$message.error("禁用失败");
          }
        })
        .catch(() => {
          // 用户取消操作
        });
    },

    async handleRestore(row) {
      this.$confirm(
        "确定要恢复这条祝福记录吗？",
        "操作确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        }
      )
        .then(async () => {
          try {
            await api.editBlessingComment({
              id: row.id,
              status: 1,
            });
            this.$message.success("恢复成功");
            this.queryData();
          } catch (error) {
            this.$message.error("恢复失败");
          }
        })
        .catch(() => {
          // 用户取消操作
        });
    },

    async batchDelete() {
      if (!this.selectedRows.length) return;
      this.$confirm(
        `确定要禁用选中的 ${this.selectedRows.length} 条祝福记录吗？`,
        "操作确认",
        {
          confirmButtonText: "确定禁用",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            // 批量禁用，逐条调用接口
            for (const row of this.selectedRows) {
              await api.editBlessingComment({
                id: row.id,
                status: 0,
              });
            }
            this.$message.success("批量禁用成功");
            this.queryData();
          } catch (error) {
            this.$message.error("批量禁用失败");
          }
        })
        .catch(() => {
          this.$message.info("已取消禁用");
        });
    },

    async batchRestore() {
      if (!this.selectedRows.length) return;
      this.$confirm(
        `确定要恢复选中的 ${this.selectedRows.length} 条祝福记录吗？`,
        "操作确认",
        {
          confirmButtonText: "确定恢复",
          cancelButtonText: "取消",
          type: "success",
        }
      )
        .then(async () => {
          try {
            // 批量恢复，逐条调用接口
            for (const row of this.selectedRows) {
              await api.editBlessingComment({
                id: row.id,
                status: 1,
              });
            }
            this.$message.success("批量恢复成功");
            this.queryData();
          } catch (error) {
            this.$message.error("批量恢复失败");
          }
        })
        .catch(() => {
          this.$message.info("已取消恢复");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.blessing-mgn-page {
  background: #fff;
  padding: 20px;
  min-height: calc(100vh - 120px);

  .filter-bar {
    padding: 16px;
    background: #fafbfc;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .table-toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
